// extracted by mini-css-extract-plugin
export var wrapper = "section-video-module--wrapper--25hGx";
export var iframeContainer = "section-video-module--iframe-container--2yqcK";
export var responsiveIframe = "section-video-module--responsive-iframe--3t0eG";